import { apiService } from "@/_services";

/**
 * Get fundamentals
 * @param {object} _this: context variables
 */
export async function getFundamentals(_this) {
  Object.assign(_this.loading, { fundamentalOptions: true });

  const params = {
    method: "GET",
    endpoint: "fundamentals",
    content_type: "application/json"
  };

  return apiService
    .getAll(params)
    .then(data => {
      parseData(data, _this);
    })
    .catch(function(error) {
      Object.assign(_this.loading, { fundamentalOptions: false });
      console.error(error);
    });
}

export async function postFundamentals(_this, queryParams) {
  Object.assign(_this.loading, { fundamentals: true });

  const params = {
    method: "POST",
    endpoint: "fundamentals/",
    content_type: "application/json",
    query_params: { ...queryParams }
  };

  return apiService
    .getAll(params)
    .then(data => {
      parseDataFundamentals(_this, data);
    })
    .catch(function(error) {
      Object.assign(_this.loading, { fundamentals: false });
      Object.assign(_this.allData, { render: false });
      console.error(error);
    });
}

function parseData(data, _this) {
  // Get fundamentals array
  const fundamentalOptions = data
    .map(d => ({
      pk_fundamental: d.pk_fundamental,
      name: d.name
    }))
    .reduce((unique, item) => {
      if (!unique.find(u => u.pk_fundamental === item.pk_fundamental)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const commodityTypes = [];
  const commodityNamesSet = new Set();
  // Create a map to track the pk_fundamental associated with each commodity
  const commodityFundamentalsMap = new Map();

  const commodityIds = [
    ...new Map(
      data
        .flatMap(item =>
          item.commodities.map(c => {
            // Find actual commodity in all commodities
            const findComm = _this.commoditySpecs.find(
              d => d.pk_idcommodity === c.pk_idcommodity
            );

            // Add pk_fundamental to the commodityFundamentalsMap
            if (!commodityFundamentalsMap.has(c.pk_idcommodity)) {
              commodityFundamentalsMap.set(c.pk_idcommodity, []);
            }
            commodityFundamentalsMap
              .get(c.pk_idcommodity)
              .push(item.pk_fundamental);

            // Add commodity types with fk
            if (
              findComm &&
              !commodityNamesSet.has(findComm.fk_idcommoditytype)
            ) {
              commodityNamesSet.add(findComm.fk_idcommoditytype);
              commodityTypes.push({
                fk_idcommoditytype: c.fk_idcommoditytype,
                name: findComm.fk_idcommoditytype
              });
            }

            // Add commodity with pk and associated fundamentals
            return {
              pk_commodity: c.pk_idcommodity,
              fk_idcommoditytype: c.fk_idcommoditytype,
              name: findComm.commodity_name,
              fk_fundamentals: commodityFundamentalsMap.get(c.pk_idcommodity)
            };
          })
        )
        .map(obj => [JSON.stringify(obj), obj]) // Convert objects to key-value pairs where key is JSON string
    ).values() // Get the unique objects
  ];

  Object.assign(_this.allData, { dataRaw: data });
  Object.assign(_this.allData, { fundamentalOptions: fundamentalOptions });
  Object.assign(_this.allData, { assetTypes: commodityTypes });
  Object.assign(_this.allData, { assetOptions: commodityIds });
  Object.assign(_this.loading, { fundamentalOptions: false });
}

function parseDataFundamentals(_this, data) {
  data.forEach(element => {
    element.year = new Date(element.observation_date).getFullYear();
    const findComm = _this.commoditySpecs.find(
      d => d.pk_idcommodity === element.fk_commodity
    );
    if (findComm) {
      element.commodityName = findComm.commodity_name;
    }
  });
  Object.assign(_this.allData, {
    fundamentals: data
  });
  _this.nestedData(data);
  Object.assign(_this.loading, { fundamentals: false });
}
